import { Avatar } from '@material-ui/core';
import logo from '../../assets/logos/logo-blue-square.jpg'

export function SignaMedLogo({size}) {    
    return (
        <Avatar className="sig_SignIn_Logo" variant="circular"
            src={logo} style={{ height: size, width: size }}/>
    )
}